import { api } from '@/api';

export default {
  upload(data) {
    return api.post('/v1/upload/', data);
  },
};
